class HeaderMobileMenu {
    constructor(root) {
        this.root   = root;
        this.toggle = root.querySelector('[data-id="widget-header__menu-toggle"]');
        this.menu   = root.querySelector('[data-id="widget-header__mobile-menu"]');

        this._bindToggle();
        this._bindLinks();
    }

    _bindToggle() {
        this.toggle.addEventListener('click', () => {
            const isOpen = !this.menu.hasAttribute('hidden');
            if (isOpen) {
                this._close();
            } else {
                this._open();
            }
        });
    }

    _bindLinks() {
        this.menu.querySelectorAll('a').forEach((link) => {
            link.addEventListener('click', () => this._close());
        });
    }

    _open() {
        this.menu.removeAttribute('hidden');
        this.toggle.setAttribute('aria-expanded', 'true');
        this.toggle.classList.add('is-open');
    }

    _close() {
        this.menu.setAttribute('hidden', '');
        this.toggle.setAttribute('aria-expanded', 'false');
        this.toggle.classList.remove('is-open');
    }
}

export default HeaderMobileMenu;